<div class="cc-tile-with-backBtn">
  <div class="title-backBtn" (click)="gotoUserGrid()"><span class="fas fa-long-arrow-alt-left"></span></div>
  <h3>{{pageTitle}}</h3>
</div>

<ngb-accordion [closeOthers]="true" #acc="ngbAccordion" class="cc-accordion" [activeIds]="activeIds" [destroyOnHide]="false" >

  <!-- Basic Settings Tab -->
  <ngb-panel id="ngb-panel-0">
    <ng-template ngbPanelTitle>
      <span class="accordion-title">{{'_General_Basic_Settings_Text_' | translate }}</span>
      <span class="caret"></span>
    </ng-template>
    <ng-template ngbPanelContent class="cc-tab-content">
      <app-user-settings (dirtyEmitter)="updateFormDirty($event)" (submittedEmitter)="updateValue($event)" (asyncUserUpdateEmitter)="asyncUserUpdate()" (closeEmitter)="acc.collapse($event)"></app-user-settings>
    </ng-template>
  </ngb-panel>

<!--Lobby Settings Tab-->
<ngb-panel id="ngb-panel-2" [disabled]="isExpandable"  *ngIf="isLTLicenseEnabled$ | async">
  <ng-template ngbPanelTitle>
    <span class="accordion-title" [title]="(isExpandable) ? collapsedTitle : '' ">{{'_General_Lobby_Settings_Text_' | translate }}</span>
    <span class="caret"></span>
  </ng-template>
  <ng-template ngbPanelContent class="cc-tab-content">
    <app-user-lobby-settings (dirtyEmitter)="updateFormDirty($event)" (closeEmitter)="acc.collapse($event)"></app-user-lobby-settings>
  </ng-template>
</ngb-panel>

  <!--Appointment Settings Tab-->
  <ngb-panel id="ngb-panel-3" [disabled]="isExpandable" *ngIf="isACLicenseEnabled$ | async" >
    <ng-template ngbPanelTitle>
      <span class="accordion-title" [title]="(isExpandable) ? collapsedTitle : '' ">{{'_General_Appointment_Settings_Text_' | translate }}</span>
      <span class="caret"></span>
    </ng-template>
    <ng-template ngbPanelContent class="cc-tab-content">
      <app-user-additional-settings (dirtyEmitter)="updateFormDirty($event)" (closeEmitter)="acc.collapse($event)" (floatChangeEmitter)="changeFloatValue()" (useAppointmentChangeEmitter)="changeUseAppointmentValue($event)" (meetingPreferenceChangeEmitter)="changeMeetingPreferenceSelection($event)" (emitReassignMeetingPreference)="reassignMeetingPreference($event)"></app-user-additional-settings>
    </ng-template>
  </ngb-panel>

    <!--Availability Template Tab-->
    <ngb-panel  class="set-pointer-events" id="ngb-panel-1" [disabled]="isExpandable" *ngIf="isACLicenseEnabled$ | async" >
      <ng-template ngbPanelTitle >
        <span class="accordion-title" [title]="(isExpandable) ? collapsedTitle : '' ">{{'_User_Available_Template_Tab_Title_Text_' | translate }}</span>
        <span class="caret"></span>
      </ng-template>
      <ng-template ngbPanelContent class="cc-tab-content">
        <app-user-availability (dirtyEmitter)="updateFormDirty($event)" (closeEmitter)="acc.collapse($event)"></app-user-availability>
      </ng-template>
    </ngb-panel>  

  <!--Skills Tab-->
  <ngb-panel  id="ngb-panel-4" [disabled]="isExpandable" *ngIf="isACLicenseEnabled$ | async" >
    <ng-template ngbPanelTitle>
      <span class="accordion-title" [title]="(isExpandable) ? collapsedTitle : '' ">{{'_User_Skills_Tab_Title_Text_' | translate }}</span>
      <span class="caret"></span>
    </ng-template>
    <ng-template ngbPanelContent class="cc-tab-content">
      <app-user-skills (closeEmitter)="acc.collapse($event)"></app-user-skills >
    </ng-template>
  </ngb-panel>
</ngb-accordion>

<ngx-spinner name="user-spinner" bdColor="rgb(0,0,0,0.6)" size="default" color="#51DCCE" type="square-loader" [fullScreen]="true">
    <p class="clr-white">
      {{'_General_Saving_Text_' | translate }} </p>
</ngx-spinner>
